let echarts = require('echarts')
//区域监测  全县工业增加值 echarts 折线图
export var industryAddOption = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县工业增加值增速',
      textStyle: {
        color: '#fff',
        fontSize: 28
      },
      // subtext: 'Industria rate of added value',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 20,
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '工业增加值增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 20
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.xaxis,
      axisLabel: {
        color: '#fff',
        fontSize: '16'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '16'
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
    },
    legend: {
      selectedMode: false,
      type: 'plain',
      data: ['累计增速 单位：%'],
      top: 120,
      left: 50,
      itemWidth: 50,
      textStyle: {
        color: '#fff',
        fontSize: 18
      }
    },
    grid: {
      top: 200,
      left: 100
    },
    series: [{
      name: "累计增速 单位：%",
      data: data.yaxisAddedValue,
      type: 'line',
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#021132' // 0% 处的颜色
          }, {
            offset: 1, color: '#44F0FF' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      },
      itemStyle: {
        color: '#44F0FF',
        borderWidth: 10
      }
    }]
  }
}
export var industryAddOptionSin = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县工业增加值增速',
      textStyle: {
        color: '#fff',
        fontSize: 20
      },
      // subtext: 'Industria rate of added value',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 14,
      top: 14
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '工业增加值增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 14
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.xaxis,
      axisLabel: {
        color: '#fff',
        fontSize: '10'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '10'
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
    },
    legend: {
      selectedMode: false,
      type: 'plain',
      data: ['累计增速 单位：%'],
      top: 84,
      left: 35,
      itemWidth: 35,
      textStyle: {
        color: '#fff',
        fontSize: 12
      }
    },
    grid: {
      top: 140,
      left: 70
    },
    series: [{
      name: "累计增速 单位：%",
      data: data.yaxisAddedValue,
      type: 'line',
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#021132' // 0% 处的颜色
          }, {
            offset: 1, color: '#44F0FF' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      },
      itemStyle: {
        color: '#44F0FF',
        borderWidth: 7
      }
    }]
  }
}
//区域监测 全县工业投资  echarts 折线图
export var industryInverstOption = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县工业投资',
      textStyle: {
        color: '#fff',
        fontSize: 28
      },
      // subtext: 'Investment in the whole city',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 20,
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '工业投资增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 20
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.xaxisInvestment,
      axisLabel: {
        color: '#fff',
        fontSize: '16'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '16'
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
    },
    legend: {
      selectedMode: false,
      type: 'plain',
      data: ['增速 单位：%'],
      top: 20,
      right: 200,
      itemWidth: 50,
      textStyle: {
        color: '#fff',
        fontSize: 18
      }
    },
    grid: {
      top: 100,
      left: 100
    },
    series: [{
      name: "增速 单位：%",
      data: data.yaxisIndustryInvestment,
      type: 'line',
      smooth: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#E6307B' // 0% 处的颜色
          }, {
            offset: 0.5, color: '#E6307B' // 50% 处的颜色
          }, {
            offset: 1, color: '#0C69CA' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      },
      itemStyle: {
        color: '#E6307B',
        borderWidth: 10,
        borderColor: '#fff'
      },
      lineStyle: {
        width: 8
      }
    }]
  }
}
export var industryInverstOptionSin = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县工业投资',
      textStyle: {
        color: '#fff',
        fontSize: 20
      },
      // subtext: 'Investment in the whole city',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 14,
      top: 14
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '工业投资增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 14
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.xaxisInvestment,
      axisLabel: {
        color: '#fff',
        fontSize: '12'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '12'
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
    },
    legend: {
      selectedMode: false,
      type: 'plain',
      data: ['增速 单位：%'],
      top: 30,
      right: 20,
      itemWidth: 35,
      textStyle: {
        color: '#fff',
        fontSize: 14
      }
    },
    grid: {
      top: 80,
      left: 70
    },
    series: [{
      name: "增速 单位：%",
      data: data.yaxisIndustryInvestment,
      type: 'line',
      smooth: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#E6307B' // 0% 处的颜色
          }, {
            offset: 0.5, color: '#E6307B' // 50% 处的颜色
          }, {
            offset: 1, color: '#0C69CA' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      },
      itemStyle: {
        color: '#E6307B',
        borderWidth: 10,
        borderColor: '#fff'
      },
      lineStyle: {
        width: 8
      }
    }]
  }
}
//区域监测  全市营业收入增速 echarts 折线图
export var inCount = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县营业收入增速',
      textStyle: {
        color: '#fff',
        fontSize: 14
      },
      // subtext: 'Industria rate of added value',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 'center',
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '营业收入增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 20
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      offset: 5,
      data: data.xaxis,
      axisLabel: {
        color: '#fff',
        fontSize: '16'
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '16',
        margin: 2
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      name: '单位：%'
    },
    grid: {
      top: 70,
      left: 40
    },
    series: [{
      name: "营业收入增速",
      data: data.yaxisAllCityStatisticIncome,
      type: 'bar',
      barWidth: 12,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#FF5A1F' // 0% 处的颜色
          }, {
            offset: 1, color: '#FFC31F' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }
    }]
  }
}
//区域监测  全市利润总额增速 echarts 折线图
export var totalCount = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县利润总额增速',
      textStyle: {
        color: '#fff',
        fontSize: 14
      },
      // subtext: 'Industria rate of added value',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 'center',
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '利润总额增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 20
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: data.xaxis,
      offset: 5,
      axisLabel: {
        color: '#fff',
        fontSize: '16'
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '16',
        margin: 2
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      name: '单位：%'
    },
    grid: {
      top: 70,
      left: 40
    },
    series: [{
      name: "利润总额增速",
      data: data.yaxisAllCityStatisticProfit,
      type: 'bar',
      barWidth: 12,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#0489F0' // 0% 处的颜色
          }, {
            offset: 1, color: '#28D8E8' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }
    }]
  }
}
//区域监测  全市营业收入增速 echarts 折线图
export var inCountSin = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县营业收入增速',
      textStyle: {
        color: '#fff',
        fontSize: 14
      },
      // subtext: 'Industria rate of added value',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 'center',
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '营业收入增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 14
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      offset: 3,
      data: data.xaxis,
      axisLabel: {
        color: '#fff',
        fontSize: '12'
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '12',
        margin: 2
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      name: '单位：%'
    },
    grid: {
      top: 50,
      left: 28
    },
    series: [{
      name: "营业收入增速",
      data: data.yaxisAllCityStatisticIncome,
      type: 'bar',
      barWidth: 10,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#FF5A1F' // 0% 处的颜色
          }, {
            offset: 1, color: '#FFC31F' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }
    }]
  }
}
//区域监测  全市利润总额增速 echarts 折线图
export var totalCountSin = function (data) {
  let Curyear = new Date().getFullYear()
  return {
    title: {
      text: '全县利润总额增速',
      textStyle: {
        color: '#fff',
        fontSize: 14
      },
      // subtext: 'Industria rate of added value',
      // subtextStyle: {
      //     fontSize: 18
      // },
      left: 'center',
    },
    tooltip: {
      //提示信息
      trigger: "item",
      formatter: function (params) {
        return '时间：' + Curyear + '年' + params.name + '<br/>' + '利润总额增速：' + params.value + '%'
      },
      textStyle: {
        fontSize: 14
      },
      extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: data.xaxis,
      offset: 5,
      axisLabel: {
        color: '#fff',
        fontSize: '12'
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#fff',
        fontSize: '12',
        margin: 2
      },
      axisLine: {
        lineStyle: {
          color: '#fff',  //坐标轴的颜色
        },
      },
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      name: '单位：%'
    },
    grid: {
      top: 60,
      left: 28
    },
    series: [{
      name: "利润总额增速",
      data: data.yaxisAllCityStatisticProfit,
      type: 'bar',
      barWidth: 10,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#0489F0' // 0% 处的颜色
          }, {
            offset: 1, color: '#28D8E8' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }
    }]
  }
}

// 区域检测 排名前5
export var rankingOne = {
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    top: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    boundaryGap: [0, 0.01],
    splitLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    }
  },
  yAxis: {
    type: 'category',
    splitLine: {
      show: false
    },
    axisLabel: {
      show: true,
      color: "#fff",
      fontSize: '16'
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    data: ['造纸和纸制品业', '纺织业', '花钱纤维制造', '食品制造业', '木材加工制品业']
  },
  series: [
    {
      name: '2011年',
      type: 'bar',
      itemStyle: {
        normal: {
          barBorderRadius: 10,
          color: function (params) {
            // build a color map as your need.
            var colorList = [
              '#B1F5F6',
              '#85FBFD',
              '#4EFBFF',
              '#00CCFF',
              '#7FFE00'
            ];
            return colorList[params.dataIndex]
          },
          label: {
            show: true,
            position: 'right',
            color: "#fff",
            formatter: '{c}%'
          }
        }
      },
      barWidth: 10,
      data: ["40", "30", "50", "20", "90"]
    }
  ]
}
export var rankingTwo = {
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    top: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    boundaryGap: [0, 0.01],
    splitLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    }
  },
  yAxis: {
    type: 'category',
    splitLine: {
      show: false
    },
    axisLabel: {
      show: true,
      color: "#fff",
      fontSize: '16'
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    data: ['造纸和纸制品业', '纺织业', '花钱纤维制造', '食品制造业', '木材加工制品业']
  },
  series: [
    {
      name: '2011年',
      type: 'bar',
      itemStyle: {
        normal: {
          barBorderRadius: 10,
          color: function (params) {
            // build a color map as your need.
            var colorList = [
              '#B1F5F6',
              '#85FBFD',
              '#4EFBFF',
              '#00CCFF',
              '#7FFE00'
            ];
            return colorList[params.dataIndex]
          },
          label: {
            show: true,
            position: 'right',
            color: "#fff",
            formatter: '{c}%'
          }
        }
      },
      barWidth: 10,
      data: ["20", "40", "10", "50", "30"]
    }
  ]
}
export var rankingThree = {
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    top: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    boundaryGap: [0, 0.01],
    splitLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    }
  },
  yAxis: {
    type: 'category',
    splitLine: {
      show: false
    },
    axisLabel: {
      show: true,
      color: "#fff",
      fontSize: '16'
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    data: ['造纸和纸制品业', '纺织业', '花钱纤维制造', '食品制造业', '木材加工制品业']
  },
  series: [
    {
      name: '2011年',
      type: 'bar',
      itemStyle: {
        normal: {
          barBorderRadius: 10,
          color: function (params) {
            // build a color map as your need.
            var colorList = [
              '#B1F5F6',
              '#85FBFD',
              '#4EFBFF',
              '#00CCFF',
              '#7FFE00'
            ];
            return colorList[params.dataIndex]
          },
          label: {
            show: true,
            position: 'right',
            color: "#fff",
            formatter: '{c}%'
          }
        }
      },
      barWidth: 10,
      data: ["60", "30", "60", "30", "33"]
    }
  ]
}
// 饼图配置函数
export var inverstPie = function (title, legend, data) {
  return {
    title: {
      text: title,
      textStyle: {
        color: '#fff',
        fontSize: 24
      },
      x: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: "{b}: {c} ({d}%)",
      textStyle: {
        fontSize: 20
      }
    },
    legend: {
      selectedMode: false,
      orient: 'vertical',
      left: 50,
      top: 20,
      data: legend,
      textStyle: {
        color: '#fff',
        fontSize: 18
      }
    },
    series: [
      {
        name: title,
        type: 'pie',
        center: ['50%', '50%'],
        radius: ['30%', '70%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: true,
            position: 'inside',
            formatter: "{d}%"
          },
          emphasis: {
            show: false,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: data
      }
    ]
  }
}
// 饼图配置函数
export var inverstPieSin = function (title, legend, data) {
  return {
    title: {
      text: title,
      textStyle: {
        color: '#fff',
        fontSize: 16
      },
      x: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: "{b}: {c} ({d}%)",
      textStyle: {
        fontSize: 14
      }
    },
    legend: {
      selectedMode: false,
      orient: 'vertical',
      left: 35,
      top: 20,
      data: legend,
      textStyle: {
        color: '#fff',
        fontSize: 12
      }
    },
    series: [
      {
        name: title,
        type: 'pie',
        center: ['50%', '50%'],
        radius: ['30%', '70%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: true,
            position: 'inside',
            formatter: "{d}%"
          },
          emphasis: {
            show: false,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: data
      }
    ]
  }
}
//三大改造情况 各区县投资情况
export var inverstCity = {
  title: {
    text: '各区县三大改造走势',
    textStyle: {
      color: '#fff',
      fontSize: 24,
    },
    x: 'center',
    top: 20
  },
  tooltip: {
    //提示信息
    trigger: "item",
    formatter: function (params) {
      return '区县：' + params.name + '<br/>' + '增速：' + params.value + '%'
    },
    textStyle: {
      fontSize: 20
    },
    extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: ['涧西区', '西工区', '老城区', '瀍河区', '洛龙区', '吉利区', '偃师市', '孟津县', '新安县', '宜阳县', '伊川县', '洛宁县', '嵩县', '栾川县', '汝阳县'],
    axisLabel: {
      color: '#fff',
      rotate: 60,
      fontSize: '16'
    },
    axisLine: {
      lineStyle: {
        color: '#fff',
        width: 1
      }
    }
  },
  yAxis: {
    type: 'value',
    axisLabel: {
      formatter: '{value} %',
      color: '#fff',
      fontSize: '16'
    },
    splitLine: {    //网格线
      lineStyle: {
        type: 'dashed'
      }  //设置网格线类型 dotted：虚线   solid:实线
    },
    axisLine: {
      lineStyle: {
        color: '#fff',
        width: 1
      }
    }
  },
  legend: {
    selectedMode: false,
    type: 'plain',
    data: ['增速 单位：%'],
    top: 20,
    right: 35,
    itemWidth: 50,
    textStyle: {
      color: '#fff',
      fontSize: 18
    }
  },
  grid: {
    top: 100,
    left: 100,

  },
  series: [{
    name: "增速 单位：%",
    data: [],
    // data: [0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0, 0, 0,1],
    type: 'bar',
    smooth: true,
    itemStyle: {
      color: '#D01864',
      borderWidth: 0,

    },
    barWidth: 12,
  }]
}
//三大改造情况 各区县投资情况
export var inverstCitySin = {
  title: {
    text: '各区县三大改造走势',
    textStyle: {
      color: '#fff',
      fontSize: 14,
    },
    x: 'center',
    top: 14
  },
  tooltip: {
    //提示信息
    trigger: "item",
    formatter: function (params) {
      return '区县：' + params.name + '<br/>' + '增速：' + params.value + '%'
    },
    textStyle: {
      fontSize: 14
    },
    extraCssText: "background:#44F0FF;padding:10px;color:#fff" //编辑tooltip的css样式
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: ['涧西区', '西工区', '老城区', '瀍河区', '洛龙区', '吉利区', '偃师市', '孟津县', '新安县', '宜阳县', '伊川县', '洛宁县', '嵩县', '栾川县', '汝阳县'],
    axisLabel: {
      color: '#fff',
      rotate: 60,
      fontSize: '12'
    },
    axisLine: {
      lineStyle: {
        color: '#fff',
        width: 1
      }
    }
  },
  yAxis: {
    type: 'value',
    axisLabel: {
      formatter: '{value} %',
      color: '#fff',
      fontSize: '12'
    },
    splitLine: {    //网格线
      lineStyle: {
        type: 'dashed'
      }  //设置网格线类型 dotted：虚线   solid:实线
    },
    axisLine: {
      lineStyle: {
        color: '#fff',
        width: 1
      }
    }
  },
  legend: {
    selectedMode: false,
    type: 'plain',
    data: ['增速 单位：%'],
    top: 14,
    right: 35,
    itemWidth: 35,
    textStyle: {
      color: '#fff',
      fontSize: 14
    }
  },
  grid: {
    top: 70,
    left: 70,

  },
  series: [{
    name: "增速 单位：%",
    data: [],
    // data: [0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0, 0, 0,1],
    type: 'bar',
    smooth: true,
    itemStyle: {
      color: '#D01864',
      borderWidth: 0,

    },
    barWidth: 8,
  }]
}
// 项目投资 平台监测项目情况
export var investTerrace = {
  title: {
    text: '各区县项目建设',
    textStyle: {
      color: '#fff',
      fontSize: '18px'
    },
    x: 'center',
    top: 20
  },
  tooltip: {
    //提示信息
    trigger: "axis",
    formatter: function (params) {
      return '时间：' + params[0].name + '<br/>' + params[0].seriesName + "：" + params[0].value + '<br/>' + params[1].seriesName + "：" + params[1].value
    },
    extraCssText: "background:#00CCCD;padding:10px;color:#fff", //编辑tooltip的css样式
    textStyle: {
      fontSize: 20
    }
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月'],
    axisLabel: {
      color: '#fff'
    }
  },
  yAxis: {
    splitLine: {    //网格线
      lineStyle: {
        type: 'dashed'
      }  //设置网格线类型 dotted：虚线   solid:实线
    },
    type: 'value',
    axisLabel: {
      formatter: '{value} 个',
      color: '#fff',
      fontSize: '16'
    },
    name: '单位：个'
  },
  legend: {
    selectedMode: false,
    type: 'plain',
    data: ['计划新建', '计划竣工'],
    top: 50,
    x: 'center',
    itemWidth: 100,
    textStyle: {
      color: '#fff',
      fontSize: 18
    }
  },
  grid: {
    top: 120,
    left: 100
  },
  series: [{
    name: "计划竣工",
    data: [],
    type: 'line',
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#407FFF' // 0% 处的颜色
        }, {
          offset: 1, color: '#00CCCD' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
    },
    itemStyle: {
      color: '#2BFAFF',
      borderWidth: 4
    },
    lineStyle: {
      width: 5
    }
  },
  {
    name: "计划新建",
    data: [],
    type: 'line',
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#407FFF' // 0% 处的颜色
        }, {
          offset: 1, color: '#FF006D' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
    },
    itemStyle: {
      color: '#D01864',
      borderWidth: 4
    },
    lineStyle: {
      width: 5
    }
  }]
}
// 项目投资 平台监测项目情况
export var investTerraceSin = {
  title: {
    text: '各区县项目建设',
    textStyle: {
      color: '#fff',
      fontSize: '14px'
    },
    x: 'center',
    top: 14
  },
  tooltip: {
    //提示信息
    trigger: "axis",
    formatter: function (params) {
      return '时间：' + params[0].name + '<br/>' + params[0].seriesName + "：" + params[0].value + '<br/>' + params[1].seriesName + "：" + params[1].value
    },
    extraCssText: "background:#00CCCD;padding:10px;color:#fff", //编辑tooltip的css样式
    textStyle: {
      fontSize: 14
    }
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月'],
    axisLabel: {
      color: '#fff'
    }
  },
  yAxis: {
    splitLine: {    //网格线
      lineStyle: {
        type: 'dashed'
      }  //设置网格线类型 dotted：虚线   solid:实线
    },
    type: 'value',
    axisLabel: {
      formatter: '{value} 个',
      color: '#fff',
      fontSize: '12'
    },
    name: '单位：个'
  },
  legend: {
    selectedMode: false,
    type: 'plain',
    data: ['计划新建', '计划竣工'],
    top: 35,
    x: 'center',
    itemWidth: 70,
    textStyle: {
      color: '#fff',
      fontSize: 14
    }
  },
  grid: {
    top: 80,
    left: 65
  },
  series: [{
    name: "计划竣工",
    data: [],
    type: 'line',
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#407FFF' // 0% 处的颜色
        }, {
          offset: 1, color: '#00CCCD' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
    },
    itemStyle: {
      color: '#2BFAFF',
      borderWidth: 2
    },
    lineStyle: {
      width: 3
    }
  },
  {
    name: "计划新建",
    data: [],
    type: 'line',
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#407FFF' // 0% 处的颜色
        }, {
          offset: 1, color: '#FF006D' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
    },
    itemStyle: {
      color: '#D01864',
      borderWidth: 2
    },
    lineStyle: {
      width: 3
    }
  }]
}
//工作台区域监测情况
export var workBenchAreaL = function (data) {
  return {
    title: {
      text: '全县' + data.title + '走势',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>' + '{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      data: data.leftDataArea.xaxis,
      axisLabel: {
        color: '#000'
      },
      boundaryGap: true,
      offset: 12,
    },
    yAxis: [
      {
        splitLine: {    //网格线
          lineStyle: {
            type: 'dashed'
          }  //设置网格线类型 dotted：虚线   solid:实线
        },
        type: 'value',
        axisLabel: {
          formatter: '{value} 亿元',
          color: '#000'
        },
        name: '单位：亿元'
      },
      {
        splitLine: {    //网格线
          lineStyle: {
            type: 'dashed'
          }  //设置网格线类型 dotted：虚线   solid:实线
        },
        type: 'value',
        axisLabel: {
          formatter: '{value} %',
          color: '#000'
        },
        name: '单位：%'
      },

    ],
    legend: {
      type: 'plain',
      selectedMode: true,
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 14
      }
    },
    grid: {
      top: 120,
      left: 30
    },
    series: [
      {
        name: "同比增速",
        data: data.leftDataArea.lineChartData,
        type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        itemStyle: {
          color: '#44F0FF',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: "当期",
        data: data.leftDataArea.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },


      },
      {
        name: "上年同期",
        data: data.leftDataArea.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
export var workBenchAreaL1 = function (data) {
  return {
    title: {
      text: '全县' + data.title + '走势',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>' + '{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff", //编辑tooltip的css样式
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      type: 'category',
      data: data.leftDataArea.xaxis,
      axisLabel: {
        color: '#000'
      },
      boundaryGap: true,
      offset: 12,
    },
    yAxis: [
      {
        splitLine: {    //网格线
          lineStyle: {
            type: 'dashed'
          }  //设置网格线类型 dotted：虚线   solid:实线
        },
        type: 'value',
        axisLabel: {
          formatter: '{value} 亿元',
          color: '#000'
        },
        name: '单位：亿元'
      },
      {
        splitLine: {    //网格线
          lineStyle: {
            type: 'dashed'
          }  //设置网格线类型 dotted：虚线   solid:实线
        },
        type: 'value',
        axisLabel: {
          formatter: '{value} %',
          color: '#000'
        },
        name: '单位：%'
      },

    ],
    legend: {
      type: 'plain',
      selectedMode: true,
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 16
      }
    },
    grid: {
      top: 120,
      left: 100
    },
    series: [
      {
        name: "同比增速",
        data: data.leftDataArea.lineChartData,
        // type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        // itemStyle: {
        //   color: '#44F0FF',
        //   borderWidth: 4
        // },
        // lineStyle: {
        //   width: 1
        // },
        // yAxisIndex: 1
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FF0000' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF00fF' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },
      },
      {
        name: "当期",
        data: data.leftDataArea.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },


      },
      {
        name: "上年同期",
        data: data.leftDataArea.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
export var workBenchAreaR = function (data) {
  var endPercent = (6 / data.rightDataArea.xaxis.length) * 160;
  return {
    title: {
      text: '各区县' + data.title + '区域监测情况',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      data: data.rightDataArea.xaxis,
      axisLabel: {
        color: '#000',
        rotate: 20,
        interval: 0,
        fontSize: 10
      },
      boundaryGap: true,
      offset: 12,
    },
    dataZoom: [
      {
        type: "slider",
        show: true,
        xAxisIndex: [0],
        left: "center",
        start: 0,
        bottom: 0,
        dataBackground: {
          lineStyle: {
            color: '#fff'
          },
          areaStyle: {
            color: '#fff'
          }
        },
        height: 10,
        handleSize: 0,
        maxValueSpan: 50,
        end: endPercent //初始化滚动条
      }
    ],
    yAxis: [{
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} 亿元',
        color: '#000'
      },
      name: '单位：亿元'
    }, {
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#000'
      },
      name: '单位：%'
    }],
    legend: {
      selectedMode: true,
      type: 'plain',
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 14
      }
    },
    grid: {
      top: 120,
      left: 30
    },
    series: [
      {
        name: "同比增速",
        data: data.rightDataArea.lineChartData,
        type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        itemStyle: {
          color: '#44F0FF',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: "当期",
        data: data.rightDataArea.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      },
      {
        name: "上年同期",
        data: data.rightDataArea.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
//工作台投资监测情况
export var workBenchIndustryL = function (data) {
  return {
    title: {
      text: '全县' + data.title + '走势',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      data: data.leftDataInvestment.xaxis.map(res => res + '月'),
      axisLabel: {
        color: '#000'
      },
      boundaryGap: true,
      offset: 12,
    },
    yAxis: [{
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} 亿元',
        color: '#000'
      },
      name: '单位：亿元'
    }, {
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#000'
      },
      name: '单位：%'
    }],
    legend: {
      selectedMode: true,
      type: 'plain',
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 14
      }
    },
    grid: {
      top: 120,
      left: 30
    },
    series: [
      {
        name: "同比增速",
        data: data.leftDataInvestment ? data.leftDataInvestment.lineChartData : data.leftDataPark.lineChartData,
        type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        itemStyle: {
          color: '#44F0FF',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: "当期",
        data: data.leftDataInvestment ? data.leftDataInvestment.yaxisFirst : data.leftDataPark.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      },
      {
        name: "上年同期",
        data: data.leftDataInvestment ? data.leftDataInvestment.yaxisSecond : data.leftDataPark.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
export var workBenchIndustryR = function (data) {
  var endPercent = (6 / data.rightDataInvestment.xaxis.length) * 160;
  return {
    title: {
      text: '各区县' + data.title + '投资监测情况',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      data: data.rightDataInvestment ? data.rightDataInvestment.xaxis : data.rightDataPark.xaxis,
      axisLabel: {
        color: '#000',
        rotate: 20,
        interval: 0,
        fontSize: 10
      },
      boundaryGap: true,
      offset: 12,
    },
    dataZoom: [
      {
        type: "slider",
        show: true,
        xAxisIndex: [0],
        left: "center",
        start: 0,
        bottom: 0,
        dataBackground: {
          lineStyle: {
            color: '#fff'
          },
          areaStyle: {
            color: '#fff'
          }
        },
        height: 10,
        handleSize: 0,
        maxValueSpan: 50,
        end: endPercent //初始化滚动条
      }
    ],
    yAxis: [{
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} 亿元',
        color: '#000'
      },
      name: '单位：亿元'
    }, {
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#000'
      },
      name: '单位：%'
    }],
    legend: {
      selectedMode: true,
      type: 'plain',
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 14
      }
    },
    grid: {
      top: 120,
      left: 30
    },
    series: [
      {
        name: "同比增速",
        data: data.rightDataInvestment ? data.rightDataInvestment.lineChartData : data.rightDataPark.lineChartData,
        type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        itemStyle: {
          color: '#44F0FF',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: "当期",
        data: data.rightDataInvestment ? data.rightDataInvestment.yaxisFirst : data.rightDataPark.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      },
      {
        name: "上年同期",
        data: data.rightDataInvestment ? data.rightDataInvestment.yaxisSecond : data.rightDataPark.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
//工作台园区监测情况
export var workBenchGardenL = function (data) {
  return {
    title: {
      text: '全县' + data.title + '走势',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      data: data.leftDataPark.xaxis.map(res => res + '月'),
      axisLabel: {
        color: '#000',
        interval: 0,
        rotate: 20,
      },
      boundaryGap: true,
      offset: 12,
    },
    yAxis: [{
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} 亿元',
        color: '#000'
      },
      name: '单位：亿元'
    }, {
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#000'
      },
      name: '单位：%'
    }],
    legend: {
      selectedMode: true,
      type: 'plain',
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 14
      }
    },
    grid: {
      top: 120,
      left: 50,
      right: 50,
      bottom: 100
    },
    series: [
      {
        name: '同比增速',
        data: data.leftDataPark.lineChartData,
        type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        itemStyle: {
          color: '#44F0FF',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: "当期",
        data: data.leftDataPark.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      },
      {
        name: "上年同期",
        data: data.leftDataPark.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
export var workBenchGardenR = function (data) {
  var endPercent = (6 / data.rightDataPark.xaxis.length) * 160;
  return {
    title: {
      text: '各园区' + data.title + '投资监测情况',
      textStyle: {
        color: '#000',
        fontSize: '18px'
      },
      x: 'center',
      top: 20
    },
    tooltip: {
      //提示信息
      trigger: "axis",
      formatter: '{b0}</br>{a0}:{c0}%' + '</br>{a1}:{c1}亿元' + '</br>{a2}:{c2}亿元',
      extraCssText: "background:#00CCCD;padding:10px;color:#fff" //编辑tooltip的css样式
    },
    xAxis: {
      type: 'category',
      data: data.rightDataPark.xaxis,
      axisLabel: {
        color: '#000',
        rotate: 20,
        interval: 0,
        fontSize: 10
      },
      boundaryGap: true,
      offset: 12,
    },
    dataZoom: [
      {
        type: "slider",
        show: true,
        xAxisIndex: [0],
        left: "center",
        start: 0,
        bottom: 0,
        dataBackground: {
          lineStyle: {
            color: '#fff'
          },
          areaStyle: {
            color: '#fff'
          }
        },
        height: 10,
        handleSize: 0,
        maxValueSpan: 50,
        end: endPercent //初始化滚动条
      }
    ],
    yAxis: [{
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} 亿元',
        color: '#000'
      },
      name: '单位：亿元'
    }, {
      splitLine: {    //网格线
        lineStyle: {
          type: 'dashed'
        }  //设置网格线类型 dotted：虚线   solid:实线
      },
      type: 'value',
      axisLabel: {
        formatter: '{value} %',
        color: '#000'
      },
      name: '单位：%'
    }],
    legend: {
      selectedMode: true,
      type: 'plain',
      data: ['同比增速', '当期', '上年同期'],
      top: 50,
      right: 50,
      itemWidth: 20,
      textStyle: {
        color: '#000000',
        fontSize: 14
      }
    },
    grid: {
      top: 120,
      left: 50,
      right: 50,
      bottom: 100
    },
    series: [
      {
        name: '同比增速',
        data: data.rightDataPark.lineChartData,
        type: 'line',
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 0, color: '#44F0FF' // 0% 处的颜色
        //     }, {
        //       offset: 1, color: '#021132' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // },
        itemStyle: {
          color: '#44F0FF',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: "当期",
        data: data.rightDataPark.yaxisFirst,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#FFC31F' // 0% 处的颜色
            }, {
              offset: 1, color: '#FF5A1F' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      },
      {
        name: "上年同期",
        data: data.rightDataPark.yaxisSecond,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#28D8E8' // 0% 处的颜色
            }, {
              offset: 1, color: '#0489F0' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },

      }
    ]
  }
}
// 政府首页检测情况
export var companyIndexSee = function (data) {
  return {
    tooltip: {
      //提示信息
      trigger: "axis",
      // backgroundColor: '#999',//鼠标移动到图上面时，显示的背景颜色
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      },
      formatter: function (params) {
        if (params.length == 2) {
          return '<i class="el-icon-date" style="color:rgba(92, 137, 255, 1)"></i>   ' + params[0].name + '<br/>' + '<br/>' + params[0].seriesName + "：" + params[0].value + '%' + '<br/>' + params[1].seriesName + "：" + params[1].value + '千元'
        } else if (params.length == 1) {
          if (params[0].seriesName == "本年累计") {
            return '<i class="el-icon-date"></i>   ' + params[0].name + '<br/>' + '<br/>' + params[0].seriesName + "：" + params[0].value + '千元'
          } else if (params[0].seriesName == "同比增速") {
            return '<i class="el-icon-date"></i>   ' + params[0].name + '<br/>' + '<br/>' + params[0].seriesName + "：" + params[0].value + '%'
          } else if (params[0].seriesName == "截止本月") {
            return '<i class="el-icon-date"></i>   ' + params[0].name + '<br/>' + '<br/>' + params[0].seriesName + "：" + params[0].value + '千元'
          }
        } else {
          return '请勾选'
        }
      },
      extraCssText: "background:#ffffff;padding:20px;color:#000" //编辑tooltip的css样式
    },

    toolbox: {
      feature: {
        dataView: { show: false, readOnly: false },
        magicType: { show: false, type: ['line', 'bar'] },
        restore: { show: false },
        saveAsImage: { show: false }
      }
    },
    legend: {
      top: '5%',
      data: data.legend,
      selectedMode: false
    },
    xAxis: [
      {
        type: 'category',
        data: data.xAxis,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    title: {
      x: 'center',
      y: 'top',
      textAlign: 'left',
      text: data.title + '监测情况'
    },
    yAxis: [
      {
        type: 'value',
        scale: true,
        name: '单位：千元',
        min: 0,
        max: data.max,
        interval: data.gird,
        axisLabel: {
          formatter: '{value}'
        }
      },
      {
        type: 'value',
        name: '单位：%',
        scale: true,
        min: data.min,
        max: 200,
        interval: 50,
        axisLabel: {
          formatter: '{value}%'
        }
      }
    ],
    grid: {
      top: 80,
      left: 50,
      right: 50,
      bottom: 30
    },
    series: [
      {
        name: data.legend[1],
        type: 'line',
        data: data.speed,
        itemStyle: {
          color: 'rgba(240, 58, 58, 1)',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: data.legend[0],
        type: 'bar',
        data: data.currentYear,
        barWidth: 30,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [
              { offset: 0, color: '#72acf6' },
              { offset: 0.5, color: '#9c9ff0' },
              { offset: 1, color: '#9979f0' }
            ]
          )
        }
      }
    ]

  }
}
// 政府首页检测情况
export var companyIndexPro = function (data) {
  return {
    tooltip: {
      //提示信息

      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      },
      trigger: "axis",
      formatter: function (params) {
        return '<i class="el-icon-date" style="color:rgba(92, 137, 255, 1)"></i>   ' + params[0].name + '<br/>' + '<br/>' + params[0].seriesName + "：" + params[0].value + '%' + '<br/>' + params[1].seriesName + "：" + params[1].value + '千元' + '<br/>' + params[2].seriesName + "：" + params[2].value + '千元'
      },
      extraCssText: "background:#ffffff;padding:20px;color:#000" //编辑tooltip的css样式
    },

    legend: {
      top: '5%',
      data: data.legend,
      selectedMode: false
    },
    title: {
      x: 'center',
      y: 'top',
      textAlign: 'left',
      text: data.title
    },
    grid: {
      top: 80,
      left: 50,
      right: 50,
      bottom: 30
    },
    xAxis: [
      {
        type: 'category',
        data: data.xAxis,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：千元',
        min: 0,
        max: data.max,
        interval: data.gird,
        axisLabel: {
          formatter: '{value}'
        }
      },
      {
        type: 'value',
        name: '单位：%',
        min: data.min,
        max: 200,
        interval: 50,
        axisLabel: {
          formatter: '{value}%'
        }
      }
    ],
    series: [
      {
        name: data.legend[2],
        type: 'line',
        data: data.proSpeed,
        itemStyle: {
          color: 'rgba(240, 58, 58, 1)',
          borderWidth: 4
        },
        lineStyle: {
          width: 1
        },
        yAxisIndex: 1
      },
      {
        name: data.legend[1],
        type: 'bar',
        data: data.currentYearSall,
        barWidth: 30,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [
              { offset: 0, color: '#72acf6' },
              { offset: 0.5, color: '#9c9ff0' },
              { offset: 1, color: '#9979f0' }
            ]
          )
        },
      },
      {
        name: data.legend[0],
        type: 'bar',
        data: data.companyIndexPro,
        barWidth: 30,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [
              { offset: 0, color: '#96f691' },
              { offset: 0.5, color: '#68eef0' },
              { offset: 1, color: '#8cccf0' }
            ]
          )
        }
      }
    ]

  }
}


